import moment, { type MomentInput } from 'moment'

export interface AvailabilityItem {
  start_at: string
  end_at: string
  unavailable: boolean
}

/**
 * Whether one of the availability items makes the user/resource unavailable during the period.
 *
 * Event dates arrive as local strings (`2026-10-07 07:30:00`) and availability items as UTC ISO
 * strings (`2026-10-07T03:00:00.000000Z`): they must be compared as instants, never as strings.
 * Periods that only touch (an event starting when the unavailability ends) do not overlap.
 */
export function hasUnavailabilityDuring(
  availabilityItems: AvailabilityItem[] | null | undefined,
  dateFrom: MomentInput,
  dateTo?: MomentInput | null
): boolean {
  const periodStart = moment(dateFrom)
  const periodEnd = moment(dateTo ?? dateFrom)

  return (availabilityItems ?? []).some((availabilityItem) => {
    if (!availabilityItem.unavailable) return false

    const unavailabilityStart = moment(availabilityItem.start_at)
    const unavailabilityEnd = moment(availabilityItem.end_at)

    if (periodStart.isSame(periodEnd)) {
      return (
        periodStart.isSameOrAfter(unavailabilityStart) &&
        periodStart.isBefore(unavailabilityEnd)
      )
    }

    return (
      periodStart.isBefore(unavailabilityEnd) &&
      periodEnd.isAfter(unavailabilityStart)
    )
  })
}
